// EditStudent Component for update student data 

// Import Modules 
import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useOutletContext } from "react-router-dom";
import axios from "axios";
import { useLocation } from "react-router-dom";
import PatientTreatmentForm from "../Forms/PatientTreatmentForm";
import CONFIG from '../../config';
import { usePatient } from "../../context/PatientContext";
import { useAuth } from "../../context/AuthProvider";
import { useTheme } from "../../context/ThemeContext";

// EditStudent Component 
const EditPatientTreatment = () => {
  const { markSectionComplete } = useOutletContext();
  const navigate = useNavigate();
  const { verifyTokenAndRedirect } = useAuth();
  const { patientData, setPatientData, selectedCase, selectedVisit, doctorInfo } = usePatient();
  const { theme } = useTheme();
  const { patientId, caseId, visitId } = useParams();
  const location = useLocation();


  useEffect(() => {

    verifyTokenAndRedirect();

  }, []);



  //onSubmit handler 
  const onSubmitHandler = (updatedPatientTreatment, options = {}) => {
    const isAutoSave = options?.isAutoSave;
    console.log('patient data after treatment updation', updatedPatientTreatment);

    const { PRESCRIPTION, ...treatmentDetails } = updatedPatientTreatment;

    const updatedData = {
      ...patientData,
      patientTreatment: patientData?.patientTreatment?.length > 0
        ? patientData.patientTreatment.map(info => ({
          ...info,
          ...treatmentDetails,
          PATIENT_ID: patientData.PATIENT_ID,
          CASE_ID: selectedCase || caseId,
          VISIT_ID: selectedVisit || visitId,
          DOCTOR_ID: doctorInfo.MANDALI_ID,
          CLINIC_ID: doctorInfo.CLINIC_ID
        }))
        : [{
          ...treatmentDetails,
          PATIENT_ID: patientData.PATIENT_ID,
          CASE_ID: selectedCase || caseId,
          VISIT_ID: selectedVisit || visitId,
          DOCTOR_ID: doctorInfo.MANDALI_ID,
          CLINIC_ID: doctorInfo.CLINIC_ID
        }],
      patientDiagnosis: patientData?.patientDiagnosis?.length > 0
        ? patientData.patientDiagnosis.map(info => ({
          ...info,
          PRESCRIPTION: PRESCRIPTION
        }))
        : [{
          PRESCRIPTION: PRESCRIPTION,
          PATIENT_ID: patientData.PATIENT_ID,
          CASE_ID: selectedCase || caseId,
          VISIT_ID: selectedVisit || visitId,
          DOCTOR_ID: doctorInfo.MANDALI_ID,
          CLINIC_ID: doctorInfo.CLINIC_ID
        }]
    };

    setPatientData(updatedData);
    markSectionComplete("treatment");
    if (!isAutoSave) {
      if (location.pathname.startsWith("/addpatient")) {
        navigate("/addpatient/payment");
      } else if (location.pathname.startsWith("/visits")) {
        navigate(`/visits/${patientId}/${caseId}/${visitId}/payment`);
      } else {
        console.warn("Unknown route, no redirection");
      }
    }

  };


  return (
    <div className="max-w-4xl mx-auto">
      <div className="mb-10">
        <h3
          className="text-2xl md:text-4xl mb-3 tracking-tight"
          style={{
            fontFamily: theme.fonts?.serif,
            color: theme.text
          }}
        >
          Treatment & Prescription
        </h3>
        <div className="h-1 w-12 rounded-full mb-6" style={{ backgroundColor: theme.primary }} />
        <p className="text-sm md:text-base opacity-60 font-medium" style={{ color: theme.textSecondary }}>
          Prescribing Ayurvedic medicines, dosages, and other therapeutic interventions.
        </p>
      </div>

      {patientData && (
        <PatientTreatmentForm
          initialValues={patientData}
          onSubmit={onSubmitHandler}
          onAutoSave={(values) => onSubmitHandler(values, { isAutoSave: true })}
          enableReinitialize={true}
        />
      )}
    </div>
  );

};

export default EditPatientTreatment;

